import GetStoreListDummyData from "../../../dummy/GetStoreListDummyData.json";
import GetStoreAdminListDummyData from "../../../dummy/GetStoreAdminListDummyData.json";
import SaveStoreDummyData from "../../../dummy/SaveStoreDummyData.json";
import UpdateStoreDummyData from "../../../dummy/UpdateStoreDummyData.json";
import DeleteStoreDummyData from "../../../dummy/DeleteStoreDummyData.json";
import GetStoreReportDetailDummyData from "../../../dummy/GetStoreReportDetailDummyData.json";
import GetStoreRecentRevenueDummyData from "../../../dummy/GetStoreRecentRevenueDummyData.json";
import GetStoreTotalRevenueDummyData from "../../../dummy/GetStoreTotalRevenueDummyData.json";
import GetStoreRevenueSummaryDummyData from "../../../dummy/GetStoreRevenueSummaryDummyData.json";
import GetStoreRevenueSummaryByStoreDummyData from "../../../dummy/GetStoreRevenueSummaryByStoreDummyData.json";
import GetStoreQrCodeDummyData from "../../../dummy/GetStoreQrCodeDummyData.json";
import GetStoreDetailDummyData from "../../../dummy/GetStoreDetailDummyData.json";
import GetStoreDeviceDummyData from "../../../dummy/GetStoreDeviceDummyData.json";
import GetStoreDeviceStatusDummyData from "../../../dummy/GetStoreDeviceStatusDummyData.json";
import GetStoreDeviceStatusSummaryDummyData from "../../../dummy/GetStoreDeviceStatusSummaryDummyData.json";
import GetDeviceMemoDummyData from "../../../dummy/GetDeviceMemoDummyData.json";
import CreateDeviceMemoDummyData from "../../../dummy/CreateDeviceMemoDummyData.json";
import UpdateDeviceMemoDummyData from "../../../dummy/UpdateDeviceMemoDummyData.json";
import DeleteDeviceMemoDummyData from "../../../dummy/DeleteDeviceMemoDummyData.json";
import SuccessResponse from "../dto/common/SuccessResponse";
import StoreListDto from "../dto/store/StoreListDto";
import StoreSaveRespDto from "../dto/store/StoreSaveRespDto";
import StoreReportDetailDto from "../dto/store/StoreReportDetailDto";
import StoreRecentRevenueDto from "../dto/store/StoreRecentRevenueDto";
import StoreTotalRevenueDto, { StoreRevenuePeriodType } from "../dto/store/StoreTotalRevenueDto";
import StoreRevenueSummaryDto from "../dto/store/StoreRevenueSummaryDto";
import StoreRevenueSummaryByStoreDto from "../dto/store/StoreRevenueSummaryByStoreDto";
import StoreQrCodeDto from "../dto/store/StoreQrCodeDto";
import StoreDetailDto from "../dto/store/StoreDetailDto";
import DeviceMemoListDto from "../dto/store/DeviceMemoListDto";
import StoreDeviceDto from "../dto/store/StoreDeviceDto";
import StoreDeviceStatusDto from "../dto/store/StoreDeviceStatusDto";
import StoreDeviceStatusSummaryDto from "../dto/store/StoreDeviceStatusSummaryDto";

class FakeStoreApi {
    getStoreDetail = async (): Promise<SuccessResponse<StoreDetailDto>> => {
        return GetStoreDetailDummyData;
    };

    getStoreList = async ({ shopName, shopCode }: { shopName?: string; shopCode?: string } = {}): Promise<
        SuccessResponse<StoreListDto>
    > => {
        const allStores = GetStoreListDummyData.result.storeInfo;
        const filtered = allStores.filter((store) => {
            const matchName = !shopName || (store.shopName ?? "").toLowerCase().includes(shopName.toLowerCase());
            const matchCode = !shopCode || (store.shopCode ?? "").toLowerCase().includes(shopCode.toLowerCase());
            return matchName && matchCode;
        });
        const { pageSize } = GetStoreListDummyData.result.page;
        return {
            ...GetStoreListDummyData,
            result: {
                ...GetStoreListDummyData.result,
                page: {
                    ...GetStoreListDummyData.result.page,
                    totalCount: filtered.length,
                    totalPage: Math.max(1, Math.ceil(filtered.length / pageSize)),
                },
                storeInfo: filtered,
            },
        };
    };

    getStoreAdminList = async (): Promise<SuccessResponse<StoreListDto>> => {
        return GetStoreAdminListDummyData;
    };

    saveStore = async (): Promise<SuccessResponse<StoreSaveRespDto>> => {
        return SaveStoreDummyData;
    };

    updateStore = async (): Promise<SuccessResponse<StoreSaveRespDto>> => {
        return UpdateStoreDummyData;
    };

    deleteStore = async (): Promise<SuccessResponse<object>> => {
        return DeleteStoreDummyData;
    };

    getStoreReportDetail = async (): Promise<SuccessResponse<StoreReportDetailDto>> => {
        return GetStoreReportDetailDummyData;
    };

    getStoreRecentRevenue = async (): Promise<SuccessResponse<StoreRecentRevenueDto[]>> => {
        return GetStoreRecentRevenueDummyData;
    };

    getStoreRevenueByStore = async ({
        periodType = "day",
        startDate,
        endDate,
    }: {
        storeId?: string;
        periodType?: StoreRevenuePeriodType;
        startDate?: string;
        endDate?: string;
    } = {}): Promise<SuccessResponse<StoreTotalRevenueDto[]>> => {
        const dummyByPeriod = GetStoreTotalRevenueDummyData as Record<string, SuccessResponse<StoreTotalRevenueDto[]>>;
        const source = dummyByPeriod[periodType] ?? dummyByPeriod.day;
        if (!startDate || !endDate) return source;
        // hour/dayofweek 은 date 필드가 없어 기간 필터링 대상이 아님 (기간 전체를 시간/요일로 집계한 결과)
        if (periodType === "hour" || periodType === "dayofweek") return source;

        // periodType 별 date 형식에 맞춰 비교 단위로 잘라 기간 필터링
        //  (year: yyyy, month: yyyy-MM, day/week: yyyy-MM-dd) — 형식이 zero-padded 이라 문자열 비교로 충분
        const sliceLen = periodType === "year" ? 4 : periodType === "month" ? 7 : 10;
        const from = startDate.slice(0, sliceLen);
        const to = endDate.slice(0, sliceLen);
        const filtered = (source.result ?? []).filter((item) => {
            const key = (item.date ?? "").slice(0, sliceLen);
            return key >= from && key <= to;
        });
        return { ...source, result: filtered };
    };

    getStoreRevenueSummary = async (): Promise<SuccessResponse<StoreRevenueSummaryDto>> => {
        return GetStoreRevenueSummaryDummyData;
    };

    getStoreRevenueSummaryByStore = async (): Promise<SuccessResponse<StoreRevenueSummaryByStoreDto>> => {
        return GetStoreRevenueSummaryByStoreDummyData;
    };

    getStoreQrCode = async (): Promise<SuccessResponse<StoreQrCodeDto>> => {
        return GetStoreQrCodeDummyData;
    };

    getStoreDevice = async ({ storeId }: { storeId: string }): Promise<SuccessResponse<StoreDeviceDto[]>> => {
        const deviceDataByStore = GetStoreDeviceDummyData as unknown as Record<
            string,
            SuccessResponse<StoreDeviceDto[]>
        >;
        return deviceDataByStore[storeId] ?? { resultCode: "0000", result: [] };
    };

    getStoreDeviceStatus = async (): Promise<SuccessResponse<StoreDeviceStatusDto>> => {
        return GetStoreDeviceStatusDummyData as unknown as SuccessResponse<StoreDeviceStatusDto>;
    };

    getStoreDeviceStatusSummary = async (): Promise<SuccessResponse<StoreDeviceStatusSummaryDto>> => {
        return GetStoreDeviceStatusSummaryDummyData as SuccessResponse<StoreDeviceStatusSummaryDto>;
    };

    getDeviceMemo = async (): Promise<SuccessResponse<DeviceMemoListDto>> => {
        return GetDeviceMemoDummyData;
    };

    createDeviceMemo = async (): Promise<SuccessResponse<object>> => {
        return CreateDeviceMemoDummyData;
    };

    updateDeviceMemo = async (): Promise<SuccessResponse<string>> => {
        return UpdateDeviceMemoDummyData;
    };

    deleteDeviceMemo = async (): Promise<SuccessResponse<string>> => {
        return DeleteDeviceMemoDummyData;
    };
}

export default FakeStoreApi;
